<ng-container *transloco="let t">
  <mat-card class="margin-xs-bottom">
    <mat-card-header>
      <mat-card-title>{{ t('notifications.document_review.title') }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="document-review-meta">
        <div><strong>{{ t('notifications.document_review.user') }}:</strong> {{ metadata.userName }}</div>
        <div><strong>{{ t('notifications.document_review.type') }}:</strong> {{ metadata.subtypeName }}</div>
        @if (metadata.originalName) {
          <div><strong>{{ t('notifications.document_review.file') }}:</strong> {{ metadata.originalName }}</div>
        }
        @if (metadata.validationBegin || metadata.validationEnd) {
          <div>
            <strong>{{ t('notifications.document_review.validity') }}:</strong>
            {{ metadata.validationBegin | date: 'mediumDate' }} – {{ metadata.validationEnd ? (metadata.validationEnd | date: 'mediumDate') : t('notifications.document_review.unlimited') }}
          </div>
        }
      </div>

      @if (documentDeleted) {
        <div class="document-review-status removed">
          <mat-icon class="material-symbols-outlined">delete_history</mat-icon>
          {{ t('notifications.document_review.document_removed', { date: metadata.documentDeletedAt | date: 'medium' }) }}
        </div>
      }

      @if (canOpenFile) {
        <button mat-stroked-button type="button" class="margin-xs-bottom" [disabled]="previewing" (click)="openPreview()">
          <mat-icon class="material-symbols-outlined">find_in_page</mat-icon>
          {{ t('notifications.document_review.open_file') }}
        </button>
      }

      @if (isAdminReview) {
        <mat-radio-group [(ngModel)]="decision" class="document-review-decision">
          <mat-radio-button value="accepted">{{ t('notifications.document_review.accept') }}</mat-radio-button>
          <mat-radio-button value="rejected">{{ t('notifications.document_review.reject') }}</mat-radio-button>
        </mat-radio-group>
        @if (decision === 'rejected') {
          <mat-form-field appearance="outline" class="document-review-reason">
            <mat-label>{{ t('notifications.document_review.rejection_reason') }}</mat-label>
            <textarea matInput rows="3" [(ngModel)]="rejectionReason"></textarea>
          </mat-form-field>
        }
        <div class="document-review-actions">
          <button mat-raised-button color="primary" type="button" [disabled]="submitting" (click)="submit()">
            {{ t('general.confirm') }}
          </button>
        </div>
      } @else if (metadata.status === 'approved') {
        <div class="document-review-status accepted">
          <mat-icon class="material-symbols-outlined">check_circle</mat-icon>
          {{ t('notifications.document_review.accepted') }}
        </div>
      } @else if (systemReason) {
        <div class="document-review-status withdrawn">
          <mat-icon class="material-symbols-outlined">history_toggle_off</mat-icon>
          {{ t(`notifications.document_review.withdrawn_${systemReason}`) }}
        </div>
      } @else if (metadata.status === 'rejected') {
        <div class="document-review-status rejected">
          <mat-icon class="material-symbols-outlined">cancel</mat-icon>
          {{ t('notifications.document_review.rejected') }}
        </div>
        @if (metadata.rejectionReason) {
          <p>{{ metadata.rejectionReason }}</p>
        }
        <p>{{ t('notifications.document_review.upload_again') }}</p>
      }
    </mat-card-content>
  </mat-card>
</ng-container>
